// removed by extract-text-webpack-plugin
module.exports = {"component":"_30mFp84luTTwUlNBOqX1zP","header":"_331QEGzQuuUNjqowJIcmW8","secondaryText":"_2S7kkrtn_shIhfvOiqwYRM","message":"_1oKvBLIkofUSLLU0tJwrMh","input":"_1PsAzsGVLBkqyxp2jgHUqP","btn":"g_sAr1VxGPqGek1A21kLV","link":"NTc-YhVvIW_6c4escOzgX","verticalSpacing":"_2KGPhFRY90FihrcVCoKkjW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/VerifyCode/VerifyCodeForm.css
// module id = 1074
// module chunks = 0